import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

export default function LinkedinShortIcon({ fill }) {
    return (
        <SvgIcon style={{ width: 24, height: 24 }}>
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask
                    id="mask0_20418_8239"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="25"
                    height="24"
                >
                    <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_20418_8239)">
                    <path
                        d="M8.2733 19.1714V8.93469H4.71003V19.1714H8.2733ZM6.49241 7.53728C7.73474 7.53728 8.50817 6.75122 8.50817 5.76886C8.48492 4.76412 7.73474 4 6.51604 4C5.2965 4 4.5 4.76412 4.5 5.76877C4.5 6.75113 5.27315 7.53719 6.46906 7.53719L6.49241 7.53728ZM10.2456 19.1714H13.8086V13.4554C13.8086 13.1499 13.8319 12.8435 13.926 12.6253C14.1835 12.0137 14.7698 11.3807 15.7543 11.3807C17.0434 11.3807 17.5593 12.3194 17.5593 13.6957V19.1714H21.1222V13.302C21.1222 10.1578 19.3646 8.6947 17.0203 8.6947C15.0983 8.6947 14.2542 9.72049 13.7852 10.4192H13.8089V8.93505H10.2458C10.2923 9.89538 10.2456 19.1714 10.2456 19.1714Z"
                        fill={fill}
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}
